import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

let token = '';
const user = JSON.parse(localStorage.getItem('user'));

if(user && user.Id){
  token = user.Id;
}

const APIHeaders = {
    'Authorization':token, 
    'Content-Type': 'application/x-www-form-urlencoded'
}
const baseUrl = process.env.REACT_APP_BASE_URL;
const createRequest = (url) => ({ url, headers: APIHeaders});

export const kycAPI = createApi({
    reducerPath: 'Kycs',
    baseQuery: fetchBaseQuery({baseUrl }),
    endpoints: (builder) => ({
        getKycs: builder.query({
            query: (id) => createRequest(`client/uploaded-files?clientId=${id}`)
        })
    }),
});

export const {
    useGetKycsQuery
} = kycAPI; 
